export default __webpack_public_path__ + "static/media/Background_00220.36c69714.png";